import { UserStaffInfo } from '@common/data-models/service/user-staff-info';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TeamMembersActions = createActionGroup({
    source: 'Team Members',
    events: {
        'Load Team Members': emptyProps(),
        'Load Team Members Success': props<{ users: UserStaffInfo[]; newUsers: UserStaffInfo[]; security: any[] }>(),
        'Set Loader State': props<{ loading: boolean }>(),
        'Set Group By Field': props<{ field: string }>(),
        'Set Sort By Field': props<{ field: string }>(),
        'Set Tab Index': props<{ index: number; group: string }>(),
        'Set Current Group': props<{ group: string }>(),
        'Set Current Page': props<{ group: string; page: number }>(),
        'Update Team Member': props<{ user: UserStaffInfo }>(),
        'Update Team Member Success': props<{ user: UserStaffInfo }>(),
        'Create Team Member': props<{ user: UserStaffInfo }>(),
        'Create Team Member Success': props<{ user: UserStaffInfo }>(),
        'Delete Team Member': props<{ user: UserStaffInfo }>(),
        'Delete Team Member Success': props<{ user: UserStaffInfo }>(),
        'Send Invitation': props<{ user: UserStaffInfo }>(),
        'Filter Team Members': props<{ team?: string; role?: string; status?: number; term?: string }>(),
    },
});
